import React from 'react'
import { Document } from '../landingpage/components/document';
import { Footer } from '../landingpage/components/footer';

export class Terms extends React.Component {

    render() {
        return (
            <>
            <title>Terms and Conditions - TigerCity AI</title>
            <div className="scroll">
                    <div className="document-view">
                        <Document classes="main">
                            <h1>Terms and Conditions</h1>
                            <p>This page provides the terms and conditions of the TigerCity AI platform.</p>
                        </Document>
                    </div>
                    <Footer/>
                </div>
            </>
        )
    }
}